import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesAboutSection from './components/FeaturesAboutSection';
import CarouselRankingSection from './components/CarouselRankingSection';
import AppContactSection from './components/AppContactSection';
import CommentsIndexSection from './components/CommentsIndexSection';
import TopicsFaqSection from './components/TopicsFaqSection';
import UpdatesSection from './components/UpdatesSection';
import MediaCardsSection from './components/MediaCardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesAboutSection />
        <CarouselRankingSection />
        <AppContactSection />
        <CommentsIndexSection />
        <TopicsFaqSection />
        <UpdatesSection />
        <MediaCardsSection />
        <Footer />
      </main>
    </div>
  );
}